import Grid from '@mui/material/Grid';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { PageSection } from '@openx/components-core/lib/PageSection/PageSection';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GetBidderCreativeQuery } from '../../../../graphql/query/creatives/GetBidderCreative.generated';
import type { AdvertiserOption } from '../../types';
import { getStatusLabels } from '../../utils';
import { creativeStatusMap } from '../utils';

type CreativeDetailsSectionProps = {
  creative: NonNullable<GetBidderCreativeQuery['bidderCreativeById']>;
  advertiserOptions: AdvertiserOption[];
};

export const CreativeDetailsSection = ({ creative, advertiserOptions }: CreativeDetailsSectionProps) => {
  const { t } = useTranslation();

  const statusLabels = useMemo(() => getStatusLabels(t), [t]);

  const advertiserName = useMemo(() => {
    const advertiser = advertiserOptions.find(
      account => account.exchange_account_network?.uid === creative.account_uid
    );

    return advertiser?.name ?? creative.account_uid;
  }, [advertiserOptions, creative.account_uid]);

  return (
    <PageSection
      divider
      title={t('Creative Details')}
      description={
        <StatusIndicator status={creativeStatusMap[creative.status]} label={statusLabels[creative.status]} />
      }
    >
      <Grid size="grow">
        <FieldDetails title={t('Advertiser')} value={advertiserName} />
        <FieldDetails title={t('Creative ID')} value={creative.crid} />
      </Grid>
    </PageSection>
  );
};
